var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransactionTemplate',{ref:"customer-invoice",staticClass:"customer-invoice",attrs:{"screenJson":_vm.getScreenJson,"backButtonRoute":_vm.backButtonRoute,"gcPopupConfig":_vm.gcPopupConfig,"paging":false}})}
var staticRenderFns = []

export { render, staticRenderFns }